import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import { Text } from '@actual-app/components/text';
import { send } from '@actual-app/core/platform/client/connection';
import type { SaasSubscriptionInfo } from '@actual-app/core/server/saas/app';

import { pushModal } from '#modals/modalsSlice';
import { useDispatch } from '#redux';

import { Setting } from './UI';

export function SubscriptionSettings() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [signedIn, setSignedIn] = useState(false);
  const [subscription, setSubscription] = useState<SaasSubscriptionInfo>(null);

  useEffect(() => {
    void send('saas-get-user').then(user => {
      setSignedIn(user != null);
      setSubscription(user?.subscription ?? null);
    });
  }, []);

  // Only meaningful when signed in with a Pesa Wise account
  if (!signedIn) {
    return null;
  }

  function statusLine(): string {
    if (!subscription) return t('No active subscription');
    if (subscription.status === 'trialing' && subscription.trialEndsAt) {
      return t('Free trial until {{date}}', {
        date: new Date(subscription.trialEndsAt * 1000).toLocaleDateString(),
      });
    }
    if (subscription.status === 'active') {
      return t('Subscription active');
    }
    return t('Subscription status: {{status}}', {
      status: subscription.status,
    });
  }

  return (
    <Setting
      primaryAction={
        <Button
          onPress={() =>
            dispatch(pushModal({ modal: { name: 'saas-subscription' } }))
          }
        >
          <Trans>Manage subscription</Trans>
        </Button>
      }
    >
      <Text>
        <Trans>
          <strong>Subscription</strong>
        </Trans>{' '}
        — {statusLine()}
      </Text>
    </Setting>
  );
}
